import { render, staticRenderFns } from "./EquipementsList.vue?vue&type=template&id=2837abf4&scoped=true&"
import script from "./EquipementsList.vue?vue&type=script&lang=js&"
export * from "./EquipementsList.vue?vue&type=script&lang=js&"
import style0 from "./EquipementsList.vue?vue&type=style&index=0&id=2837abf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837abf4",
  null
  
)

export default component.exports